import { z } from "zod";
import { vehicleStatusSchema, vehicleTypeSchema } from "../_shared";

export const getVehicleByUuidResponseSchema = z.object({
  uuid: z.uuid(),
  registrationNumber: z.string().nullable(),
  vehicleType: vehicleTypeSchema,
  model: z.string().nullable(),
  status: vehicleStatusSchema,
  deliveryDate: z.iso.datetime().nullable(),
  company: z.uuid(),
  rule: z.uuid().nullable(),
  driver: z.uuid().nullable(),
  providerId: z.string().nullable(),
  reference: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  deactivatedAt: z.iso.datetime().nullable(),
  identifier: z.string().nullable(),
  additionalCostPerKm: z.number().nullable(),
  contractStartDate: z.iso.datetime().nullable(),
  contractEndDate: z.iso.datetime().nullable(),
  hasAnalyticsActivatedAt: z.iso.datetime().nullable(),
  hasAdvancedAnalyticsActivatedAt: z.iso.datetime().nullable(),
  latestTelemetryMileage: z.number().nullable(),
  contractMileage: z.number().nullable(),
  latestTelemetryMileageDate: z.iso.datetime().nullable(),
  analyticCode: z.string().nullable(),
  noteTaking: z.string().nullable(),
  hasTelemetry: z.boolean(),
  lastLatitude: z.number().nullable(),
  lastLongitude: z.number().nullable(),
  lastPositionDate: z.iso.datetime().nullable(),
  department: z.uuid().nullable(),
  lastTechnicalInspectionDate: z.iso.datetime().nullable(),
});

export type GetVehicleByUuidResponse = z.infer<
  typeof getVehicleByUuidResponseSchema
>;
